import { Flex } from "@mantine/core";
import { BoxTitle, Container } from "./StyledComponents";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { theme } from "../../theme";
import styled from "styled-components";
import { useFilterContext } from "../../context/DashboardFilterContext";
import { getLiveWeeklyAnalysis } from "../../api/dashboardApi";
import { useEffect, useState } from "react";

const WeeklyAttendanceAnalysis = ({ flex }: { flex: any }) => {
  const { filters } = useFilterContext();
  const [chartData, setChartData] = useState<any>();
  const [stats, setStats] = useState<any>();

  const getBarChartData = async () => {
    try {
      const { data, success }: any = await getLiveWeeklyAnalysis(filters);
      if (success) {
        setChartData(data?.chart);
        setStats(data?.stats);
      } else {
        //error
      }
    } catch (error) {}
  };

  useEffect(() => {
    getBarChartData();
  }, [filters]);

  return (
    <Container $flex={flex}>
      <Flex justify={"space-between"}>
        <BoxTitle>Haftalık Devam Analizi</BoxTitle>
        <Flex gap={12}>
          <Flex gap={4} align={"center"}>
            <ColorCircle $color={theme.colors.alert.green} />
            <LegendText>Mevcut</LegendText>
          </Flex>
          <Flex gap={4} align={"center"}>
            <ColorCircle $color={theme.colors.alert.red} />
            <LegendText>Geç Kalanlar</LegendText>
          </Flex>
          <Flex gap={4} align={"center"}>
            <ColorCircle $color={theme.colors.alert.orange} />
            <LegendText>Erken Çıkanlar</LegendText>
          </Flex>
        </Flex>
      </Flex>
      <Flex h={"236"}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{ top: 0, right: 0, left: -30, bottom: 0 }}
          >
            <CartesianGrid vertical={false} strokeDasharray="3 3" />
            <XAxis axisLine={false} tickLine={false} dataKey="day" />
            <YAxis
              axisLine={false}
              tickLine={false}
              tickFormatter={(value) => (value === 0 ? "" : value)}
            />
            <Bar dataKey="present" fill={theme.colors.alert.green} radius={2} />
            <Bar
              dataKey="earylExit"
              fill={theme.colors.alert.orange}
              radius={2}
            />
            <Bar dataKey="late" fill={theme.colors.alert.red} radius={2} />
          </BarChart>
        </ResponsiveContainer>
      </Flex>
      <Flex gap={12}>
        <Box $bg="#ECFDF3" $color={theme.colors.alert.green}>
          <div className="count">%{stats?.averageAttendancePercent}</div>
          <div className="text">Ortalama Devam</div>
        </Box>
        <Box $bg="#FFFAEB" $color={theme.colors.alert.orange}>
          <div className="count">{stats?.totalEarlyExits}</div>
          <div className="text">Erken Çıkanlar</div>
        </Box>
        <Box $bg="#FEF3F2" $color={theme.colors.alert.red}>
          <div className="count">{stats?.totalLates}</div>
          <div className="text">Geç Kalanlar</div>
        </Box>
      </Flex>
    </Container>
  );
};
export default WeeklyAttendanceAnalysis;

const Box = styled.div<{ $bg: string; $color: string }>`
  display: flex;
  flex: 1;
  min-width: max-content;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 12px;
  border-radius: 4px;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};

  .count {
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
  }

  .text {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }
`;

const ColorCircle = styled.div<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;

const LegendText = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${theme.colors.greyscale.gray80};
  line-height: 16px;
`;
